import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { useForm } from 'react-hook-form';
import CircularProgress from '@mui/material/CircularProgress';
import { FormInputText } from 'components/Common/Forms/FormTextField';
import { getStudentAdditionalInfo } from 'layouts/students/service/studentsApi';

const IepTeacher = (props) => {
  const { studentId } = props;
  const [studentAdditionalInfo, setStudentAdditionalInfo] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (studentId) {
      fetchStudentAdditionalInfo();
    }
  }, [studentId]);

  const fetchStudentAdditionalInfo = async () => {
    setIsLoading(true);
    const studentAdditionalInfoData = await getStudentAdditionalInfo(studentId);
    setStudentAdditionalInfo(studentAdditionalInfoData);
    setIsLoading(false);
  };

  const defaultValue = {
    iepTeacher: studentAdditionalInfo?.item?.iepTeacher,
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
  });

  const { reset, control } = useFunction;

  useEffect(() => {
    reset(defaultValue);
  }, [defaultValue.iepTeacher]);

  return (
    <>
      {isLoading ? (
        <CircularProgress color='inherit' />
      ) : (
        <Grid item xs={3}>
          <FormInputText
            name='iepTeacher'
            type='text'
            control={control}
            label='Iep Teacher'
            readOnly={true}
          />
        </Grid>
      )}
    </>
  );
};

export default IepTeacher;
